// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingPanelSubheading_root__3quRk"};